import React, { Component } from 'react';
import { connect } from 'react-redux';

import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import StationInfo from '../../fast-data/view/StationInfo';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';

import FlexOne from '../../common-components/FlexOne';
import LoadingOverlay from '../../common-components/LoadingOverlay';

import * as userStationsReducers from '../../system/reducer/UserStationsReducers';
import * as slowDataReducers from '../../slow-data/reducer';
import * as fastDataReducers from '../../fast-data/reducer/index';

import * as slowDataActionMgr from '../../slow-data/action-mgr';
import * as healthDataActionMgr from '../../health-data/action-mgr';
import * as fastDataActionMgr from '../../fast-data/action-mgr';

import * as actionMgr from '../action-mgr';
import * as Reducers from '../reducer';

import { topicPrefix, imgTopicPrefix } from '../../fast-data/constants';

import * as mqttMgr from '../../helpers/MqttMgr';
import * as strings from '../../helpers/strings';
import { getFastDataStationId, setFastDataStationId } from '../../helpers/common';
// importing Css
import '../../index.css';

const styles = {
  graphViewButton: { height: 30, border: "1px solid rgba(0,0,0,0.5)", lineHeight: "30px", paddingLeft: 16, paddingRight: 16 },
  selected: { background: "rgba(0,0,0,0.1)" }
}

class DMYLineGraphScreen extends Component {

  constructor() {
    super();

    this.handleStationChange = this.handleStationChange.bind(this);
    this.loadData = this.loadData.bind(this);
    this.MQTTStationChange = this.MQTTStationChange.bind(this);
    this.handleFastData = this.handleFastData.bind(this);
  }

  componentDidMount() {
    document.getElementsByClassName("errorTypeDecs")[0].remove()
  }

  componentWillMount() {
    const { fetchGraphReferences, selectStation, stations } = this.props;
    var defaultStation;
    if (stations.length > 0) {
      if (stations.filter(station => station.id === getFastDataStationId()).length !== 0) {
        defaultStation = stations.filter(station => station.id === getFastDataStationId())[0].id;
      } else {
        defaultStation = stations[0].id;
      }

      selectStation(defaultStation);
      fetchGraphReferences(defaultStation);
    }
  }

  handleStationChange = event => {
    const { selectStation, getFindRealTimeFields, selectFastStation, fetchGraphReferences, getStationTimeOffset, stations, resetSelectFields } = this.props;

    const selectedStationId = event.target.value;
    resetSelectFields();
    selectStation(selectedStationId);
    selectFastStation(selectedStationId);

    fetchGraphReferences(selectedStationId);

    const selectedStation = stations.filter(station => station.id === selectedStationId)[0];
    getStationTimeOffset(selectedStation)

    const selectedName = stations.filter(station => station.id === selectedStationId)[0].name;
    getFindRealTimeFields(selectedName);

    this.MQTTStationChange(selectedStationId)
  }

  MQTTStationChange = (stationId) => {
    const { stations, selectStation, fastSelectedId, setSitePhotos, selectStationHealth, getStationTimeOffset } = this.props;
    if (stationId !== fastSelectedId) {
      setFastDataStationId(stationId);

      if (fastSelectedId) {
        const stationName = stations.filter(station => station.id === fastSelectedId)[0].name;
        mqttMgr.removeSubscriptionTopic(`${topicPrefix}${stationName}`);
        mqttMgr.removeSubscriptionTopic(`${imgTopicPrefix}${stationName}`);
      }

      const station = stations.filter(station => station.id === stationId)[0];
      const stationName = station.name;

      getStationTimeOffset(station)
        .then(() => {
          mqttMgr.addSubscriptionTopic(`${topicPrefix}${stationName}`, this.handleFastData);
          mqttMgr.sqsService(stationName)
        })
      mqttMgr.addSubscriptionTopic(`${imgTopicPrefix}${stationName}`, setSitePhotos);
      selectStation(stationId);
      selectStationHealth(stationName);
    }
  }

  handleFastData = (fastData) => {
    const { fastStationTimeOffset, addFastData } = this.props;
    const targetDate = new Date(fastData.timestamp);

    var timestamp = targetDate.getTime() / 1000 + targetDate.getTimezoneOffset() * 60 // Current UTC date/time expressed as seconds since midnight, January 1, 1970 UTC
    var offsets = fastStationTimeOffset.dstOffset * 1000 + fastStationTimeOffset.rawOffset * 1000 // get DST and time zone offsets in milliseconds
    var localdate = new Date(timestamp * 1000 + offsets) // Date object containing current time of target location
    var refreshDate = new Date() // get current date again to calculate time elapsed between targetDate and now
    var millisecondselapsed = refreshDate - targetDate // get amount of time elapsed between targetDate and now
    localdate.setMilliseconds(localdate.getMilliseconds() + millisecondselapsed) // update localdate to account for any time elapsed

    fastData.timestamp = localdate.getTime();
    addFastData(fastData);
  }

  loadData = (stationId) => {
    const { stations, getFindRealTimeFields } = this.props;
    const selectedName = stations.filter(station => station.id === stationId)[0].name;
    getFindRealTimeFields(selectedName);
  }

  render = () => {
    const { stations, selectedStationId, isFetching, isGraphReferenceFetching } = this.props;
    let location = "";

    const selectedStation = stations.filter(station => station.id === selectedStationId)[0];

    const sortStations = stations.sort((a, b) => (a.name > b.name) ? 1 : -1)

    if (selectedStation)
      location = selectedStation.location;

    return (
      <div className="fastStationData">
        {(isGraphReferenceFetching || isFetching) && <LoadingOverlay />}
        <Paper className="fastStationDataPaper" >
          <Grid container alignItems="center">
            <FormControl margin={strings.txtNormal}>
              <InputLabel className="filterLabelSelect" htmlFor={strings.idSelectStation}>{strings.lblStation}</InputLabel>
              <Select
                value={selectedStationId}
                onChange={this.handleStationChange}
                inputProps={{
                  name: strings.lblStation,
                  id: strings.idSelectStation,
                }}
              >
                {sortStations.map(station =>
                  <MenuItem key={station.id} value={station.id} >{station.name} - {station.description}</MenuItem>
                )}
              </Select>
            </FormControl>
            <FlexOne />
            <div  className="stnInfo">
              <StationInfo/>
            </div>
          </Grid>
          
          {/* <Typography variant="body1">{location}</Typography> */}
        </Paper>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  stations: userStationsReducers.getStations(state),
  selectedStationId: slowDataReducers.getStationId(state),
  yearIndices: slowDataReducers.getYearIndices(state),
  stationTimeOffset: slowDataReducers.getStationTimeOffset(state),
  findStationFields: slowDataReducers.getFindStationFields(state),
  getSelectedField: slowDataReducers.getSelectedField(state),

  fastStationTimeOffset: fastDataReducers.getStationTimeOffset(state),
  fastSelectedId: fastDataReducers.getSelectedStationId(state),

  getFindStationRealtimeFields: Reducers.getFindStationRealtimeFields(state),
});

const mapActionsToProps = {
  getFindRealTimeFields: actionMgr.getFindRealTimeFields,
  resetSelectFields: actionMgr.resetSelectFields,

  toggleField: slowDataActionMgr.toggleField,
  selectStation: slowDataActionMgr.selectStation,
  fetchGraphReferences: slowDataActionMgr.fetchGraphReferences,
  getFindStationFields: slowDataActionMgr.getFindStationFields,

  getStationTimeOffset: fastDataActionMgr.getStationTimeOffset,
  selectStationHealth: healthDataActionMgr.selectStation,
  addFastData: fastDataActionMgr.addFastData,
  selectFastStation: fastDataActionMgr.selectStation,
};

export default connect(mapStateToProps, mapActionsToProps)(
  withStyles(styles)(DMYLineGraphScreen)
);